<app-header id="header"></app-header>
<div class="form_div">
  <div class="form_header {{ tabSelected === 0 ? 'pt' : '' }}" *ngIf="!isMobile || (tabSelected !== 1 && isMobile)">
    <h1 class="form_header_title">{{ 'landing.form.title' | translatePipe }}</h1>
    <p class="form_header_description" *ngIf="tabSelected <= 1">{{ 'landing.form.description' | translatePipe }}</p>
    <p class="form_header_description" *ngIf="tabSelected > 1">{{ 'landing.form.description2' | translatePipe }}</p>
    <div class="intro_mobile" *ngIf="tabSelected === 0">
      <div class="button-div">
        <button class="my-button active" (click)="nextStep(tabSelected + 1)">{{ 'landing.form.next' | translatePipe }}<img src="{{ images.arrow_next_active }}"></button>
      </div>
    </div>
  </div>
  <div class="form_content" *ngIf="tabSelected > 0">
    <div class="form_stepper">
      <div class="step" *ngFor="let tab of myFormClass.tabs">
        <div class="number-div {{ tab.order <= tabSelected ? 'active' : 'inactive' }}">
          <div class="line"></div>
          <div class="number">{{ tab.order }}</div>
        </div>
        <div class="text-div">
          <h1 class="title">{{ 'landing.form.' + tab.name | translatePipe }}</h1>
          <h2 class="subtitle">{{ 'landing.form.' + tab.name + '_subtitle' | translatePipe }}</h2>
        </div>
      </div>
    </div>
    <div class="step-div {{ tab.order === tabSelected ? 'active' : 'inactive' }}" *ngFor="let tab of myFormClass.tabs">
      <h2 class="title_items" *ngIf="tab.order === 1">{{ 'landing.form.items' | translatePipe }}</h2>
      <h2 class="title_items" *ngIf="tab.order === 2">{{ 'landing.form.personal' | translatePipe }}</h2>
      <h2 class="title_items" *ngIf="tab.order === 3">{{ 'landing.form.digital' | translatePipe }}</h2>
      <app-field-form *ngFor="let input of tab.cells" class="{{ input.cols }}"
                      [myClass]="myFormClass"
                      [model]="myFormClass.model"
                      [name]="input.name"
                      [cellType]="input.cellType"
                      [required]="input.required"
                      [label]="input.label">
      </app-field-form>
      <hr class="my-hr">
      <div class="button-div">
        <button *ngIf="tab.order < 3" class="my-button {{ isCompleteTab(tab) ? 'active' : 'inactive' }}" (click)="isCompleteTab(tab) ? nextStep(tab.order + 1) : {}">{{ 'landing.form.next' | translatePipe }}<img src="{{ isCompleteTab(tab) ? images.arrow_next_active : images.arrow_next }}"></button>
        <button *ngIf="tab.order === 3"class="my-button {{ isCompleteTab(tab) ? 'active' : 'inactive' }}" (click)="isCompleteTab(tab) ? sendForm() : {}">{{ 'landing.form.submit' | translatePipe }}<img src="{{ isCompleteTab(tab) ? images.arrow_next_active : images.arrow_next }}"></button>
      </div>
    </div>
  </div>
</div>
<div class="pop-up" id="downloadqr" *ngIf="showPopup">
  <div class="pop-up-bg"></div>
  <div class="pop-up-content">
    <div class="close-img" (click)="close()"><img src="{{ images.close }}"></div>
    <div class="face-img"><img src="{{ images.face }}"></div>
    <h1 class="title">{{ 'landing.form.date_registered' | translatePipe }}</h1>
    <div class="qr-img"><img src="{{ imagesQR }}"></div>
    <!-- p class="download" (click)="print()"><img src="{{ images.download }}">{{ 'landing.form.download' | translatePipe }}</p -->
    <p class="text">{{ userName }}<br>{{ 'landing.form.uses' | translatePipe }}</p>
    <div class="button-div">
      <button class="my-button active" (click)="close()">{{ 'landing.form.close' | translatePipe }}</button>
    </div>
  </div>
</div>
